module.exports = __webpack_public_path__ + "f62b32f0be82b0a6d6942467ca871fa8.svg";